// // src/utils/permissionUtils.js
import { getCurrentUser, MAINTENANCE_BYPASS_EMAIL, isTasksAdminEmail } from "./auth";

export { isTasksAdminEmail };

export const hasPermission = (permissionCode, action) => {
    const modules = JSON.parse(localStorage.getItem("modules") || "[]");
  
    for (const m of modules) {
      const found = m.permissions.find(p => p.code === permissionCode);
      if (found && found.actions.includes(action)) {
        return true;
      }
    }
    return false;
};

/** Kết xuất Excel công việc — permission `hrm.tasks.export` + chỉ administrator@hamesoft.com */
export const TASKS_EXPORT_PERMISSION = "hrm.tasks.export";

export const canExportHrmTasksData = () => {
  const user = getCurrentUser();
  const email = String(user?.email || "").trim().toLowerCase();
  if (email !== String(MAINTENANCE_BYPASS_EMAIL).toLowerCase()) return false;
  return (
    hasPermission(TASKS_EXPORT_PERMISSION, "E") ||
    hasPermission(TASKS_EXPORT_PERMISSION, "R")
  );
};

/** HC / Kế toán HQ: xem & sửa lương, hợp đồng, ngày phép — gán permission `hrm.employees_sensitive` (R/U) trong hệ thống */
export const hasEmployeeSensitivePermission = (action = "R") =>
  hasPermission("hrm.employees_sensitive", action);

/** Menu: một mục có `featureCodes` thì chỉ cần R trên một mã; không thì dùng `featureCode`. */
export const menuItemHasReadAccess = (item) => {
  if (!item) return false;
  const codes =
    Array.isArray(item.featureCodes) && item.featureCodes.length > 0
      ? item.featureCodes
      : item.featureCode
        ? [item.featureCode]
        : [];
  return codes.some((code) => hasPermission(code, "R"));
};
  